module.exports = __webpack_public_path__ + "static/media/banner.7994ae96.png";